import React from 'react';
import ReactDOM from 'react-dom/client';
import RenderPage from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RenderPage />,
);
